import { ReactNode } from "react";

type Color = "green" | "blue" | "yellow" | "red" | "gray" | "purple";

type BadgeProps = {
  color?: Color;
  dot?: boolean;
  children: ReactNode;
};

/**
 * 状態表示用バッジ
 */
export const Badge = ({ color = "gray", dot, children }: BadgeProps) => {
  return (
    <span className={`badge badge-${color}`}>
      {dot && <span className="badge-dot" />}
      {children}
    </span>
  );
};
